<template>
	<div>
		<el-card>
			<div slot="header">
				<span class="top_title">系统公告</span>
			</div>
			<el-radio-group v-model="radio" style="margin-bottom:20px" @change="changeSelect">
				<el-radio :label="-1">全部消息</el-radio>
				<el-radio :label="0">仅显示未读</el-radio>
				<el-radio :label="1">仅显示已读</el-radio>
			</el-radio-group>
			<div class="searchItem">
				<div class="search">
					<span class="searchtips">类型:</span>
					<el-select v-model="selectLabel" placeholder="" clearable style="width:140px" @change="changeSelect">
						<el-option
							v-for="(item, index) in labelList"
							:key="index"
							:value="item"
							:label="item"
							style="
								height: 40px;
								padding: 10px;
								line-height: 20px;
							"
						/>
					</el-select>
				</div>
			</div>
			<div v-if="tableData.length==0" class="empty_notice">
				<div>暂无公告</div>
			</div>
			<div v-else v-for="(item,index) in tableData" :key="index" class="notice_card" @click="toInfoDetail(item)">
				<div>{{item.title}}</div>
				<div>{{item.edate}}</div>
			</div>
			<el-pagination style="text-align: right;" @size-change="handleSizeChange($event)" @current-change="handleCurrentChange($event)"
				:current-page="currentPage" :page-sizes="[20, 50, 120, 250]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="totalNum" :pager-count="5">
			</el-pagination>
		</el-card>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				listLoading:false,
				activeName: '系统公告',
				currentPage: 1,
				totalNum: 0,
				pageSize: 20,
				tableData: [],
				radio:0,
				labelList:[],
				selectLabel:''
			};
		},
		created(){
			this.listLoading = true;
			this.getData();
			this.getLabel();
		},
		methods: {
			changeSelect(){
				this.currentPage = 1;
				this.getData();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getData();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData();
			},
			toInfoDetail(e) {
				this.$router.push({
					path: "/sysMessageDetail",
					name: "系统公告详情",
					query:{id:e.id},
				})
			},
			getLabel(){
				this.$api.getLabels().then(res=>{
					if(res.data.code==1){
						res.data.data.forEach(e => {
							this.labelList.push(e);
						});
					}
				})
			},
			getData(){
				let obj = {
					page:this.currentPage,
					limit:this.pageSize,
				}
				if(this.radio==0){
					obj.read = 0;
				}else if(this.radio==1){
					obj.read = 1;
				}
				if(this.selectLabel){
					obj.label = this.selectLabel;
				}
				this.$api.noticeGetNotice(obj).then((res)=>{
					let data = res.data.data;
					this.totalNum = res.data.count;
					this.tableData = data;
					this.listLoading = false;
				})
			}
		},
	};
</script>

<style lang='scss' scoped>
.notice_card{
	margin-bottom: 20px;
	height: 40px;
	line-height: 40px;
	font-size: 14px;
	border: 1px solid #EBEEF5;
	padding:0 20px;
	border-radius: 10px;
	box-shadow: 0 2px 12px #EEE;
	display:flex;
	justify-content: space-between;
	cursor: pointer;
}
.empty_notice{
	height: 50px;
	background: #f0f2f7;
	margin-bottom: 22px;
	line-height: 50px;
	text-align: center;
	font-size: 14px;
	color: #999999;
	border-radius: 10px;
}
</style>